export const isBoardPreviewEnabledSelector = (state) => state.getIn(['app', 'boardPreview', 'enabled']);
